<template>
    <div class="form">
        <h4 class="step-title">
            <label for="email">What is your email?</label>
        </h4>
        <ValidationObserver v-slot="{ errors, invalid, handleSubmit }" @submit.prevent>
            <div class="step-content d-flex flex-column align-items-center">
                <div class="step-item">
                    <div class="form-group mb-0">
                        <div class="m-2">
                            <ValidationProvider mode="eager" vid="email" name="Email" rules="required|email">
                                <input id="email" class="form-control" placeholder="email address" type="email" v-on:keyup.enter="enterKeyup" v-model="lead.email">
                            </ValidationProvider>
                        </div>
                        <div class="m-2" v-if="errors['email'] && errors['email'].length > 0">
                            <div class="alert alert-danger">{{ errors["email"][0] }}</div>
                        </div>
                    </div>
                </div>
                <div class="step-item" v-if="!completed">
                    <button class="btn step-btn" ref="complete" v-on:click="handleSubmit(complete)">Continue</button>
                </div>
                <div class="step-item" v-if="completed">
                    <div class="spinner-border text-light" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
            <SlotInvalidInputWatchComponent v-bind:invalid="invalid" v-bind:value="lead.email" v-on:invalidInput="onInvalidInput" />
        </ValidationObserver>
    </div>
</template>

<script>
    import { extend } from 'vee-validate';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { required, email } from 'vee-validate/dist/rules';
    import SlotInvalidInputWatchComponent from "./shared/SlotInvalidInputWatchComponent.vue";

    extend("required", {
        ...required,
        message: "{_field_} is required."
    });

    extend("email", {
        ...email,
        message: "Invalid email."
    });

    export default {
        name: "Email",
        components: {
            ValidationProvider,
            ValidationObserver,
            SlotInvalidInputWatchComponent
        },
        data: function() {
            return {
                completed: false
            }
        },
        props: {
            lead: Object
        },
        methods: {
            enterKeyup: function() {
                this.$refs.complete.click();
            },
            complete: function() {
                this.$emit("complete", this.$options.name, this.lead.email);
                this.completed = true;
            },
            onInvalidInput: function(value) {
                this.utils.log("onInvalidInput: " + value);
                this.$emit("invalidInput", this.$options.name, value);
            }
        }
    }
</script>
